<template>
  <div>
    <div class="presentation-iframe__wrap">
      <iframe
        id="presentation"
        class="presentation-iframe"
        :src="presentationUrl"
        allowfullscreen
        scrolling="no"
        frameborder="0"
      >
      </iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActionPresentationContent',
  props: {
    state: {},
  },
  watch: {
    'state.presentationState'(val) {
      if (!val) return;
      this.updateSlidePosition(val);
    },
  },
  computed: {
    presentationUrl() {
      const { presentationUrl } = this.state;
      if (!presentationUrl) return '';
      return `${presentationUrl}/embed?postMessageEvents=true`;
    },
  },
  methods: {
    async updateSlidePosition() {
      await this.$nextTick();
      if (!this.state?.presentationState) return;

      const { indexh, indexv } = this.state.presentationState || {};
      const iframeEl = this.$el.querySelector('.presentation-iframe');
      const data = JSON.stringify({ method: 'slide', args: [indexh, indexv] });
      if (iframeEl) {
        iframeEl.contentWindow.postMessage(data, '*');
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.updateSlidePosition();
    }, 500);
  },
};
</script>
